module.exports = __webpack_public_path__ + "static/media/google.80fa4bca.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/logos/google.png
// module id = 902
// module chunks = 0